//for medical Guide page sidebar navigation
(function () {
    var toc = document.querySelector('.table-of-contents-new');
    var tocItems;

// Factor of screen size that the element must cross
// before it's considered visible
    var TOP_MARGIN = 0.2,
        BOTTOM_MARGIN = 0.3;
    var pathLength;
    var lastPathStart,
        lastPathEnd;

    window.addEventListener('resize', drawPath, false);
    window.addEventListener('scroll', sync, false);

    drawPath();

    function drawPath() {
        if (toc) {
            tocItems = [].slice.call(toc.querySelectorAll('.table-of-contents-new li'));
            // Cache element references and measurements
            tocItems = tocItems.map(function (item) {
                var anchor = item.querySelector('a');
                var target = document.getElementById(anchor.getAttribute('href').slice(1));
                return {
                    listItem: item,
                    anchor: anchor,
                    target: target
                };
            });

            // Remove missing targets
            tocItems = tocItems.filter(function (item) {
                return !!item.target;
            });

            sync();
        }
    }

    function sync() {
        var windowHeight = window.innerHeight;
        var pathStart = pathLength,
            pathEnd = 0;
        var visibleItems = 0;

        if (tocItems) {
            tocItems.forEach(function (item) {
                var targetBounds = item.target.getBoundingClientRect();
                if (targetBounds.bottom > windowHeight * TOP_MARGIN && targetBounds.top < windowHeight * (1 - BOTTOM_MARGIN)) {
                    pathStart = Math.min(item.pathStart, pathStart);
                    pathEnd = Math.max(item.pathEnd, pathEnd);
                    visibleItems += 1;

                    item.listItem.classList.add('visible');
                } else {
                    item.listItem.classList.remove('visible');
                }
            });

            lastPathStart = pathStart;
            lastPathEnd = pathEnd;
        }
    }
})();

(function ($) {
    let header = $(".site-header");

    let headerHeight = $('header').outerHeight() ? $('header').outerHeight() + 20 : 0 ;

    //back to top page button
    $(window).scroll(function(){
        if($(this).scrollTop()>1000){
            $(".js-back_to_top").fadeIn(800);
        }else{
            $(".js-back_to_top").fadeOut();
        }
    });

    $('.js-back_to_top').on('click', function() {
        $("html,body").animate({scrollTop: 0},1000);
    });

    /* Go to anchor link on click event */
    $('a[href*=#]:not([href=#])').click(function () {
        if ( !$(this).parent().hasClass("toc-item") ) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
                || location.hostname === this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - headerHeight - 50
                    }, 1000);
                    return false;
                }

                /* delete hash from the URL */
                window.location.href.split('#')[0];
            }
        }
    });

    // check screen width (mobile or desktop)
    function isMobile() {
        return $(window).width() <= 768;
    }

    // for Guide Page add gradient for tables overflow
    function checkTableWidth() {
        var $table = $('.page-template-med-mal-guides-new table');
        var $tableParent = $table.parent();

        if($table.width() > $tableParent.width()) {
            $tableParent.addClass('scroll-indicate').closest('.table-wrapper').find('.scroll_me-animation').addClass('is-shown');
        } else {
            $tableParent.removeClass('scroll-indicate').closest('.table-wrapper').find('.scroll_me-animation').removeClass('is-shown');
        }
    }

    var sortableTable = $('table.sortable');

    if( sortableTable ) {

        function compare(idx) {
            return function(a, b) {
                var a_val = $(a).text().toLowerCase();
                var b_val = $(b).text().toLowerCase();
                if (a_val>b_val){
                    return 1;
                }
                if (a_val<b_val){
                    return -1;
                }
                return 0;
            }
        }

        function compareRating(reverse = false) {
            let marks = {"A": 5, "++": 1,  "+": 0.5, "-": -0.5, "--": -1,};

            return function(a, b) {
                let mark1 = $(a).find('td.rating').text().toUpperCase();
                var mark2 = $(b).find('td.rating').text().toUpperCase();

                let value1 = mark1.split("").reduce(function(total, e) {
                    total += marks[e];
                    return total;
                }, 0);

                let value2 = mark2.split("").reduce(function(total, e) {
                    total += marks[e];
                    return total;
                }, 0);

                if (reverse) {
                    if (value2 > value1) {
                        return -1;

                    }
                    if (value2 < value1) {
                        return 1;
                    }
                } else {
                    if (value2 > value1) {
                        return 1;

                    }
                    if (value2 < value1) {
                        return -1;
                    }
                }

                return 0;
            }
        }

        function sortNumWithDataAttr(idx) {
            return function(a, b) {
                var a_val = parseInt($(a).find('td.num').attr('data-sortval'));
                var b_val = parseInt($(b).find('td.num').attr('data-sortval'));
                if (a_val>b_val){
                    return 1;
                }
                if (a_val<b_val){
                    return -1;
                }
                return 0;
            }
        }

        $('th.sortData').on('click', function(){
            var table = $(this).parents('table').eq(0);
            var ths = table.find('tr:gt(0)').toArray().sort(compare($(this).index()));
            this.asc = !this.asc;
            if (!this.asc)
                ths = ths.reverse();
            for (var i = 0; i < ths.length; i++)
                table.append(ths[i]);
        });

        $('th.sortRating').on('click', function(){
            var table = $(this).parents('table').eq(0);
            var ths = table.find('tr:gt(0)').toArray().sort(compare($(this).index())).sort(compareRating());
            this.asc = !this.asc;
            if (!this.asc)
                ths = table.find('tr:gt(0)').toArray().sort(compareRating(true));
            for (var i = 0; i < ths.length; i++)
                table.append(ths[i]);
        });

        $('th.sortNumbers').on('click', function(){
            var table = $(this).parents('table').eq(0);
            var ths = table.find('tr:gt(0)').toArray().sort(sortNumWithDataAttr($(this).index()));
            this.asc = !this.asc;
            if (!this.asc)
                ths = ths.reverse();
            for (var i = 0; i < ths.length; i++)
                table.append(ths[i]);
        });

    }

    /* Secrets Pages */
    let hiddenSecretsBlock = $('.hidden-secrets');

    function showHiddenContent() {
        hiddenSecretsBlock.removeClass('is-secret');
    }

    $(document).on("gform_confirmation_loaded", function (e) {
        // code to run upon successful form submission
        showHiddenContent();
    });

    if( hiddenSecretsBlock.hasClass('show') ) {
        showHiddenContent();
    }

    // resize trigger func
    $(window).on('load resize orientationchange', function() {
        isMobile();
        checkTableWidth();
    });

    /* add/remove focus to elements depending on the input method */
    $(document).on("mousedown", function() {
        $(document).find("body").removeClass("keys-used");
        $(document).find("body").addClass("mouse-used");
    });

    $(document).on("keydown", function(e) {
        if(e.key === "Tab") {
            $(document).find("body").removeClass("mouse-used");
            $(document).find("body").addClass("keys-used");
        }
    });

    $(document).on("touchstart", function(e) {
        $(document).find("body").removeClass("mouse-used");
        $(document).find("body").addClass("touch-used");
    });
})(jQuery);

/* Lazy Loading for images */
document.addEventListener("DOMContentLoaded", function () {
    var lazyImages = document.querySelectorAll('img[data-src]');

    if ('IntersectionObserver' in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    }
});


